import Reenrollment from 'pages/reenrollment';
import Onboarding from 'pages/onboarding';
import Profile from 'pages/profile';
import ProfileConfirmation from 'pages/profile/confirmation';
import BoletoBill from 'pages/shared/boleto';
import PaymentReceipt from 'pages/shared/receipt';
import CreditCardBill from 'pages/current-bill/credit-card';
import NextBills from 'pages/next-bills';
import NBPaymentMethods from 'pages/next-bills/payment-methods';
import NBPix from 'pages/next-bills/pix';
import NBCreditCard from 'pages/next-bills/credit-card';
import NBNewCreditCard from 'pages/next-bills/new-credit-card';
import PaymentsHistory from 'pages/payments-history';
import ContractPayment from 'pages/contract-payment';
import ContractPaymentCreditCard from 'pages/contract-payment/credit-card';
import ContractPaymentBoleto from 'pages/contract-payment/boleto';
import ContractPaymentPix from 'pages/contract-payment/pix';
import ContractPaymentSuccess from 'pages/contract-payment/success';
import ChangePaymentMethod from 'pages/change-payment-method';
import CPMCreditCardSelection from 'pages/change-payment-method/credit-card-selection';
import CPMNewCreditCard from 'pages/change-payment-method/new-credit-card';
import CPMSuccess from 'pages/change-payment-method/success';
import OverdueBills from 'pages/overdue-bills';
import Contacts from 'pages/contacts';
import PaymentConfiguration from 'pages/payment-configuration';
import PaymentConfigurationCard from 'pages/payment-configuration/card';
import PaymentConfigurationDueDay from 'pages/payment-configuration/due-day-selection';
import PaymentConfigurationConfirmation from 'pages/payment-configuration/confirmation';
import BillPaymentSuccess from 'pages/shared/bill-payment-success';

const breadcrumbs = {
  panel: { label: 'Quero Pago', route: 'panel' },
  'next-bills': { label: 'Próximas mensalidades', route: 'next-bills' },
  'nb-payment-methods': { label: 'Forma de pagamento', route: 'nb-payment-methods' },
  'payments-history': { label: 'Histórico de pagamentos', route: 'payments-history' },
  'change-payment-method': { label: 'Trocar forma de pagamento', route: 'change-payment-method' },
  'cpm-credit-card-selection': { label: 'Selecionar cartão de crédito', route: 'cpm-credit-card-selection' },
  'contract-payment': { label: 'Pagar todo o periodo', route: 'contract-payment' },
  'cp-credit-card': { label: 'Cartão de crédito', route: 'cp-credit-card' },
  'cp-boleto': { label: 'Boleto', route: 'cp-boleto' },
  'cp-pix': { label: 'Pix', route: 'cp-pix' },
  'quero-pontos': { label: 'Recompensas', route: 'quero-pontos' },
  reenrollment: { label: 'Rematrícula', route: 'reenrollment' },
};

function crumb(route, { current } = {}) {
  if (current) {
    return { label: breadcrumbs[route].label };
  }

  return breadcrumbs[route];
}

const routes = [
  {
    path: '/como-funciona',
    name: 'onboarding',
    component: Onboarding,
  },
  {
    path: '/rematricula',
    name: 'reenrollment',
    component: Reenrollment,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          { label: 'Rematrícula' },
        ],
      },
    },
  },
  {
    path: '/rematricula/pagamento/cartao-de-credito',
    name: 'reenrollment-credit-card',
    component: NBCreditCard,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('reenrollment'),
          { label: 'Cartão de Crédito' },
        ],
      },
    },
  },
  {
    path: '/rematricula/pagamento/boleto',
    name: 'reenrollment-boleto',
    component: BoletoBill,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('reenrollment'),
          { label: 'Boleto' },
        ],
      },
    },
  },
  {
    path: '/rematricula/pagamento/pix',
    name: 'reenrollment-pix',
    component: NBPix,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('reenrollment'),
          { label: 'Pix' },
        ],
      },
    },
  },
  {
    path: '/dados-pessoais',
    name: 'profile',
    component: Profile,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          { label: 'Meus dados' },
        ],
      },
    },
  },
  {
    path: '/dados-pessoais/confirmacao',
    name: 'profile-confirmation',
    component: ProfileConfirmation,
  },
  {
    path: '/mensalidades',
    name: 'next-bills',
    component: NextBills,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('next-bills', { current: true }),
        ],
      },
    },
  },
  {
    path: '/mensalidades/:billId/forma-de-pagamento',
    name: 'nb-payment-methods',
    component: NBPaymentMethods,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('next-bills'),
          { label: 'Forma de pagamento' },
        ],
      },
    },
  },
  {
    path: '/boleto/:billId',
    name: 'bill-boleto',
    component: BoletoBill,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          { label: 'Pagar boleto' },
        ],
        'next-bills': [
          crumb('panel'),
          crumb('next-bills'),
          crumb('nb-payment-methods'),
          { label: 'Boleto' },
        ],
      },
    },
  },
  {
    path: '/mensalidades/:billId/pagamento/cartao-de-credito',
    name: 'nb-credit-card',
    component: NBCreditCard,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('next-bills'),
          crumb('nb-payment-methods'),
          { label: 'Cartão de Crédito' },
        ],
      },
    },
  },
  {
    path: '/mensalidades/:billId/pagamento/pix',
    name: 'nb-pix',
    component: NBPix,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('next-bills'),
          crumb('nb-payment-methods'),
          { label: 'Pix' },
        ],
      },
    },
  },
  {
    path: '/mensalidades/:billId/pagamento/novo-cartao-de-credito',
    name: 'nb-new-credit-card',
    component: NBNewCreditCard,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('next-bills'),
          crumb('nb-payment-methods'),
          { label: 'Cartão de Crédito' },
        ],
      },
    },
  },
  {
    path: '/cobranca/:billId',
    name: 'bill-credit-card',
    component: CreditCardBill,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          { label: 'Cartão de Crédito' },
        ],
      },
    },
  },
  {
    path: '/comprovante/:billId',
    name: 'payment-receipt',
    component: PaymentReceipt,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          { label: 'Comprovante de pagamento' },
        ],
        'payments-history': [
          crumb('panel'),
          crumb('payments-history'),
          { label: 'Comprovante de pagamento' },
        ],
      },
    },
  },
  {
    path: '/historico-de-pagamentos',
    name: 'payments-history',
    component: PaymentsHistory,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('payments-history', { current: true }),
        ],
      },
    },
  },
  {
    path: '/pagar-periodo',
    name: 'contract-payment',
    component: ContractPayment,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('contract-payment', { current: true }),
        ],
      },
    },
  },
  {
    path: '/pagar-periodo/cartao-credito',
    name: 'cp-credit-card',
    component: ContractPaymentCreditCard,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('contract-payment'),
          crumb('cp-credit-card', { current: true }),
        ],
      },
    },
  },
  {
    path: '/pagar-periodo/boleto',
    name: 'cp-boleto',
    component: ContractPaymentBoleto,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('contract-payment'),
          crumb('cp-boleto', { current: true }),
        ],
      },
    },
  },
  {
    path: '/pagar-periodo/pix',
    name: 'cp-pix',
    component: ContractPaymentPix,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('contract-payment'),
          crumb('cp-pix', { current: true }),
        ],
      },
    },
  },
  {
    path: '/pagar-periodo/sucesso',
    name: 'contract-payment-success',
    component: ContractPaymentSuccess,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('contract-payment', { current: true }),
          { label: 'Comprovante' },
        ],
      },
    },
  },
  {
    path: '/mensalidades-atrasadas',
    name: 'overdue-bills',
    component: OverdueBills,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          { label: 'Mensalidades atrasadas' },
        ],
      },
    },
  },
  {
    path: '/mudar-forma-de-pagamento',
    name: 'change-payment-method',
    component: ChangePaymentMethod,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('change-payment-method', { current: true }),
        ],
      },
    },
  },
  {
    path: '/mudar-forma-de-pagamento/selecionar-cartao-de-credito',
    name: 'cpm-credit-card-selection',
    component: CPMCreditCardSelection,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('change-payment-method'),
          crumb('cpm-credit-card-selection', { current: true }),
        ],
      },
    },
  },
  {
    path: '/mudar-forma-de-pagamento/cadastrar-cartao-de-credito',
    name: 'cpm-new-credit-card',
    component: CPMNewCreditCard,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          crumb('change-payment-method'),
          { label: 'Cadastrar novo cartão de crédito' },
        ],
      },
    },
  },
  {
    path: '/mudar-forma-de-pagamento/confirmacao',
    name: 'cpm-success',
    component: CPMSuccess,
  },
  {
    path: '/falar-com-o-quero-pago',
    name: 'contacts',
    component: Contacts,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          { label: 'Dúvidas? Fale com a gente' },
        ],
      },
    },
  },
  {
    path: '/configurar-pagamento',
    name: 'payment-configuration',
    component: PaymentConfiguration,
  },
  {
    path: '/configurar-pagamento/cartao-de-credito',
    name: 'payment-configuration-credit-card',
    component: PaymentConfigurationCard,
    props: { cardType: 'credit_card' },
    meta: {
      breadcrumb: {
        default: [
          { label: 'Formas de pagamento', route: 'payment-configuration' },
          { label: 'Cartão de Crédito' },
        ],
      },
    },
  },
  {
    path: '/configurar-pagamento/data-de-cobranca',
    name: 'payment-configuration-due-day',
    component: PaymentConfigurationDueDay,
    meta: {
      breadcrumb: {
        default: [
          crumb('panel'),
          { label: 'Data para cobrança' },
        ],
      },
    },
  },
  {
    path: '/configurar-pagamento/confirmacao',
    name: 'payment-configuration-confirmation',
    component: PaymentConfigurationConfirmation,
  },
  {
    path: '/mensalidade/:billId/confirmacao',
    name: 'bill-payment-success',
    component: BillPaymentSuccess,
  },
];

export default routes;
